<div class="container locker-visor">
  @if (loading == 1) {
    <h1 class="loading-title" role="status">{{'visor.generate.reserve'|traduccion}}</h1>
  }
  @if (loading == 2) {
    <header class="reservation-header">
      <div><h1>{{'visor.title'|traduccion}}</h1><p class="reservation-name">{{resumePayment.userData?.name}}</p></div>
      @if (canceled || closed || active) {
        <span class="reservation-status" [class.status-ended]="canceled || closed" role="status">
          <span class="status-dot" aria-hidden="true"></span>
          @if (canceled) {
            {{subscription ? ('visor.resume.subscriptionCancelled'|traduccion) : ('visor.resume.reserveCancelled'|traduccion)}}
          } @else if (closed) {
            {{'visor.resume.reserveClosed'|traduccion}}
          } @else {
            {{'visor.resume.reserveActive'|traduccion}}
          }
        </span>
      }
    </header>

    <section class="reservation-card overview-card">
      <div class="overview-field"><span class="icon-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></svg></span><div><p class="field-label">{{'visor.label.kioskAddress'|traduccion}}</p><strong>{{resumePayment.kioskAddress}}</strong></div></div>
      <div class="overview-field"><span class="icon-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="6" width="16" height="16" rx="2"/><path d="m4 6 2-4h12l2 4M4 8h16M8 17h8"/></svg></span><div><p class="field-label">{{'visor.label.totalReserved'|traduccion}}</p><strong>{{resumePayment.items.length}}</strong></div></div>
    </section>

    <section class="reservation-card content-card">
      <span class="icon-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M8 2v6M16 2v6M4 10h16M8 15h8"/></svg></span>
      <div class="card-content">
        <h2>{{'visor.resume.track'|traduccion}}</h2>
        <div class="date-grid">
          <div class="date-field"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M8 2v6M16 2v6M4 10h16M8 15h8"/></svg><div><p class="field-label">{{'visor.from'|traduccion}}</p><strong>{{resumePayment.startDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es'}}</strong></div></div>
          <div class="date-field"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M8 2v6M16 2v6M4 10h16M8 15h8"/></svg><div><p class="field-label">{{'visor.to'|traduccion}}</p><strong>{{resumePayment.endDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es'}}</strong></div></div>
        </div>
      </div>
    </section>

    @if (!canceled) {
      <section class="reservation-card content-card locker-card">
        <span class="icon-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M8 6h8M8 10h8M8 18h8"/></svg></span>
        <div class="card-content">
          <h2>{{'visor.resume.lockerDetails'|traduccion}}</h2>
          @for (item of resumePayment.items; track item) {
            <div class="locker-item">
              <div class="locker-fields">
                <div><p class="field-label">{{'visor.resume.nLocker'|traduccion}}</p><strong>{{item.nLocker}}</strong></div>
                <div><p class="field-label">{{'visor.resumen.typeLocker'|traduccion}}</p><strong>{{item.categoryCode|traduccion:'name'}}</strong></div>
              </div>
              @if (!subscription && item.unpaid) {
                <button type="button" class="btn btn-primary action-button pay-button" (click)="goToPay(item)">{{'visor.bt.toPay'|traduccion}}</button>
              }
              <div class="price-lines">
                <div class="price-row unit-price"><span>{{'visor.price'|traduccion}}</span><span>{{item.unitPrice}}€ / {{item.period}} {{item.unit|traduccion}}</span></div>
                <div class="price-row"><span>{{'visor.subtotal'|traduccion}}</span><span>{{item.totalPrice}} €</span></div>
              </div>
            </div>
          }
          <div class="reservation-total"><span>{{'visor.total'|traduccion}}</span><strong>{{resumePayment.total}}€</strong></div>
        </div>
      </section>
    }

    @if (!canceled && !closed) {
      <section class="reservation-card content-card email-card">
        <span class="icon-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 6 10 7 10-7"/></svg></span>
        <div class="card-content">
          <p class="email-heading">{{'visor.resume.noticeSendEmail'|traduccion}}<strong>{{resumePayment.userData.email}}</strong></p>
          <p class="email-description">{{'visor.resume.noticeResendEmail'|traduccion}}</p>
          <button type="button" class="btn btn-primary action-button" (click)="resendEmail()" [disabled]="waitingTime != null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 6 10 7 10-7"/></svg>{{'visor.bt.resendEmail'|traduccion}}</button>
          @if (waitingTime) { <p class="waiting-message text-danger" role="status">{{waitingTime}}</p> }
        </div>
      </section>
    }

    <section class="reservation-card cancellation-card">
      <span class="icon-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7v1"/></svg></span>
      <div class="card-content">
        @if (cancelable) {
          <button type="button" class="btn btn-primary action-button" [disabled]="!cancelable" (click)="cancelCheckoutCard()">{{subscription ? ('visor.bt.subscription.cancel'|traduccion) : ('visor.bt.cancel'|traduccion)}}</button>
          <p>{{'visor.resume.cancelAllow'|traduccion}}</p>
        } @else if (!canceled) {
          <p>{{'visor.resume.cancelNotAllow'|traduccion}}</p>
        }
        @if (canceled) {
          <p class="text-danger">{{subscription ? ('visor.resume.subscriptionCancelled'|traduccion) : ('visor.resume.reserveCancelled'|traduccion)}}</p>
        }
        @if (closed && !canceled) { <p class="text-danger">{{'visor.resume.reserveClosed'|traduccion}}</p> }
      </div>
    </section>
  }
</div>
